// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.find-filters {
  margin-bottom: 14px;
}

.find-input-ico {
  position: relative;
}

.find-input-ico svg {
  position: absolute;
  top: 50%;
  left: 13px;
  transform: translateY(-50%);
  color: var(--muted2);
  pointer-events: none;
}

.find-input-ico .f-input {
  padding-left: 38px;
}

.find-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
}

.find-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 15px 16px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
  text-decoration: none;
  transition: border-color 0.2s, transform 0.15s;
}

.find-card:hover {
  border-color: var(--brand-300);
  transform: translateY(-2px);
}

.find-avatar {
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  object-fit: cover;
}

.find-avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--grad-brand);
  color: #fff;
  font-family: var(--font-display);
  font-size: 0.88rem;
  font-weight: 700;
}

.find-body {
  min-width: 0;
}

.find-body strong {
  display: block;
  font-family: var(--font-display);
  font-size: 0.96rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 3px;
}

.find-cats {
  margin-top: 6px;
  font-size: 0.78rem;
  line-height: 1.45;
  color: var(--muted2);
}

.find-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 20px;
  font-size: 0.78rem;
  color: var(--muted2);
}
`, "",{"version":3,"sources":["webpack://./src/app/client/FindProviders.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".find-filters {\n  margin-bottom: 14px;\n}\n\n.find-input-ico {\n  position: relative;\n}\n\n.find-input-ico svg {\n  position: absolute;\n  top: 50%;\n  left: 13px;\n  transform: translateY(-50%);\n  color: var(--muted2);\n  pointer-events: none;\n}\n\n.find-input-ico .f-input {\n  padding-left: 38px;\n}\n\n.find-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));\n}\n\n.find-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 15px 16px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n  text-decoration: none;\n  transition: border-color 0.2s, transform 0.15s;\n}\n\n.find-card:hover {\n  border-color: var(--brand-300);\n  transform: translateY(-2px);\n}\n\n.find-avatar {\n  flex-shrink: 0;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.find-avatar-fallback {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--grad-brand);\n  color: #fff;\n  font-family: var(--font-display);\n  font-size: 0.88rem;\n  font-weight: 700;\n}\n\n.find-body {\n  min-width: 0;\n}\n\n.find-body strong {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 0.96rem;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 3px;\n}\n\n.find-cats {\n  margin-top: 6px;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: var(--muted2);\n}\n\n.find-note {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  margin-top: 20px;\n  font-size: 0.78rem;\n  color: var(--muted2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
